/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
import * as ReactDOM from "react-dom";

import { EnrollmentsApp } from "./pages/enrollments-app";

require("../enrollment.css");

ReactDOM.render(<EnrollmentsApp />, document.getElementById("contentWrapper"));
